import React, { Component } from 'react'
import Responsive from '../../components/Responsive';
import Collapsible from 'react-collapsible';
import { checkTranslation, imageAddress, priceStandardView, translate } from '../../utils/useful';
import DataGrid from '../../components/DataGrid';
import ProductViewBox from './ProductViewBox';
import HttpServices from '../../utils/Http.services';
import ProductsView from './ProductsView';
import SimilarProducts from './SimilarProducts';
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as actions from "../../stores/actionsList";
import Modal from '../../components/Modal';
import CheckboxInput from '../../components/inputs/CheckboxInput';
import TextAreaInput from '../../components/inputs/TextAreaInput';
import AddToCardButton from '../../components/tableComponents/AddToCardButton';
import SingleProductVariants from './SingleProductVariants';
import SingleProductAdditionals from './SingleProductAdditionals';
class SingleProduct extends Component {
    state = {

        save: false,
        // collapse: true,
        collapsOpen: { 0: true },
        // singleAli: [
        //     { src: '/assets/icons/more.svg', title: '{{lang}}Personalize them for free', link: '{{lang}}Personnalisation gratuite', text: '{{lang}}Engrave a mix of emoji, names, initials, and numbers to make AirPods unmistakably yours. Only at Apple' },

        // ],

        info: {
            available: true,
            status: 1
        },


        activeVariants: {},
        variantsPriceDifferences: {},

        // information: [
        //     {
        //         name: "{{lang}}Product Information", children: [
        //             {
        //                 title: "{{lang}}Overview", children: [
        //                     { title: "Rebuilt from the sound up", des: "AirPods Pro (2nd generation) have been reengineered to deliver up to 2x more Active Noise Cancellation. Adaptive Transparency reduces external noise, while Personalized Spatial Audio immerses you in sound. A single charge delivers up to 6 hours of battery life.⁷ And Touch control lets you easily adjust volume with a swipe. The revamped MagSafe Charging Case is a marvel on its own with Precision Finding¹⁵, built-in speaker, and lanyard loop.˄" },
        //                     { title: "Superior audio quality", des: "The upgraded H2 chip powers smarter noise cancellation and three-dimensional sound. Adaptive EQ tunes music to your ears in real time to deliver crisp, clean high notes and deep, rich bass in stunning clarity." },
        //                     { title: "Up to 2x more noise cancellation¹", des: "Active Noise Cancellation now cancels twice as much unwanted noise, so nothing interrupts your listening during a commute and when you need to focus.¹ And Adaptive Transparency reduces and adjusts down the intensity of loud noises at 48,000 times per second, so you can comfortably stay connected to the world around you in any setting." },
        //                     { title: "Personalized listening", des: "A listening experience all your own. Pick from four sizes of flexible silicone ear tips (XS, S, M, L) for an ideal acoustic seal and fit. Personalized Spatial Audio with dynamic head tracking tailors the listening experience by precisely placing sound elements in the space around you.º Adaptive EQ tunes music to your ears, so you hear consistently detailed playback, every time." },
        //                 ]
        //             },
        //             {
        //                 title: "{{lang}}Highlight", children: [
        //                     { title: "Designed by Apple" },
        //                     { title: "H2 Apple Silicon, amazing sound quality with Adaptive EQ" },
        //                     { title: "Personalized Spatial Audio with dynamic head trackingº" },
        //                     { title: "Active Noise Cancellation" },
        //                     { title: "Four silicone ear tip sizes for a more customizable fit and seal" },
        //                     { title: "Adaptive Transparency" },
        //                 ]
        //             },
        //             {
        //                 title: "{{lang}}What's in the Box", children: [
        //                     { title: "AirPods Pro" },
        //                     { title: "MagSafe Charging Case with speaker and lanyard loop" },
        //                     { title: "Silicone ear tips (four sizes: XS, S, M, L)" },
        //                     { title: "Lightning to USB-C Cable" },
        //                     { title: "Documentation" },
        //                 ]
        //             },
        //         ]
        //     },
        //     {
        //         name: "{{lang}}Compatibility", children: [
        //             {
        //                 title: "{{lang}}Overview", children: [
        //                     { title: "Rebuilt from the sound up", des: "AirPods Pro (2nd generation) have been reengineered to deliver up to 2x more Active Noise Cancellation. Adaptive Transparency reduces external noise, while Personalized Spatial Audio immerses you in sound. A single charge delivers up to 6 hours of battery life.⁷ And Touch control lets you easily adjust volume with a swipe. The revamped MagSafe Charging Case is a marvel on its own with Precision Finding¹⁵, built-in speaker, and lanyard loop.˄" },
        //                     { title: "Superior audio quality", des: "The upgraded H2 chip powers smarter noise cancellation and three-dimensional sound. Adaptive EQ tunes music to your ears in real time to deliver crisp, clean high notes and deep, rich bass in stunning clarity." },
        //                     { title: "Up to 2x more noise cancellation¹", des: "Active Noise Cancellation now cancels twice as much unwanted noise, so nothing interrupts your listening during a commute and when you need to focus.¹ And Adaptive Transparency reduces and adjusts down the intensity of loud noises at 48,000 times per second, so you can comfortably stay connected to the world around you in any setting." },
        //                     { title: "Personalized listening", des: "A listening experience all your own. Pick from four sizes of flexible silicone ear tips (XS, S, M, L) for an ideal acoustic seal and fit. Personalized Spatial Audio with dynamic head tracking tailors the listening experience by precisely placing sound elements in the space around you.º Adaptive EQ tunes music to your ears, so you hear consistently detailed playback, every time." },
        //                 ]
        //             },
        //             {
        //                 title: "{{lang}}Highlight", children: [
        //                     { title: "Designed by Apple" },
        //                     { title: "H2 Apple Silicon, amazing sound quality with Adaptive EQ" },
        //                     { title: "Personalized Spatial Audio with dynamic head trackingº" },
        //                     { title: "Active Noise Cancellation" },
        //                     { title: "Four silicone ear tip sizes for a more customizable fit and seal" },
        //                     { title: "Adaptive Transparency" },
        //                 ]
        //             },
        //             {
        //                 title: "{{lang}}What's in the Box", children: [
        //                     { title: "AirPods Pro" },
        //                     { title: "MagSafe Charging Case with speaker and lanyard loop" },
        //                     { title: "Silicone ear tips (four sizes: XS, S, M, L)" },
        //                     { title: "Lightning to USB-C Cable" },
        //                     { title: "Documentation" },
        //                 ]
        //             },
        //         ]
        //     },
        // ],

        // specification: [
        //     { title: "Battery", des: "Up to 6 hours of listening time with a single charge (up to 5.5 hours with Spatial Audio and Head Tracking enabled)" },
        //     { title: "Connectivity", des: "Bluetooth 5.3 wireless technology" },
        //     { title: "System Requirements", des: "iPhone and iPod touch models with the latest version of iOS iPad models with the latest version of iPadOS Apple Watch models with the latest version of watchOS Mac models with the latest version of macOS Apple TV models with the latest version of tvOS" },
        //     { title: "Audio Technology", des: "Custom high-excursion Apple driver" },
        //     { title: "Sensors", des: "Dual beamforming microphones" },
        //     { title: "Chip", des: "Apple H2 headphone chip" },
        // ],

        // images: [
        //     // { img: '/images/p1.png' },
        //     // { img: '/images/p2.png' },
        //     // { img: '/images/p3.png' },
        //     // { img: '/images/p4.png' },
        //     // { img: '/images/p5.png' },
        //     // { img: '/images/p6.png' },
        //     // { img: '/images/p7.png' },
        //     // { img: '/images/p8.png' },
        // ],
        // showphoto: null

    }



    componentDidMount() {

        // this.fetchMyProducts()
        this.getOneProduct()
        // this.getCart()
        // this.setState({ showphoto: this.state.images[1] })
        if (this.props.setHeader) {

            this.props.setHeader({
                'toolbar': null,
                'showToolbar': false,
                topHeaderComponent: this.topHeaderComponent,
                backAction: () => this.props.changePage('')

            })

        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.cart != this.props.cart) {
            // console.log('hereeeeeeeeeee');
            this.checkCart()
        }
    }


    plusNum() {


        this.props.actions.addToCart({ data: this.props.info, product: this.state.product, finalPrice: this.state.finalPrice })

        // this.setState({ num: this.state.num + 1 })
    }
    // minusNum() {


    //     this.props.actions.reduceFromCart({ data: this.props.info, product: this.state.product, finalPrice: this.state.finalPrice })

    //     // this.setState({ num: this.state.num - 1 })

    //     // if (this.state.num <= 0) {
    //     //     this.setState({ num: 0 });

    //     // }

    // }
    //   addToCart = () => {
    //     if (this.props.info?.status == '1' && this.props.info?.available) {
    //         this.plusNum()
    //     }
    // }



    // countCart = () => {
    //     let count = 0
    //     let info = this.props.info
    //     for (let i = 0; i < this.props.cart?.items?.length; i++) {
    //         let item = this.props.cart.items[i]
    //         if (item?.data?._id == info._id && item.product?.colorHEX == this.state.product?.colorHEX) {
    //             count = count + item.count
    //         }

    //     }


    //     return count
    // }

    collapsOpen = (index) => {
        let open = this.state.collapsOpen
        open[index] = !open[index]
        this.setState(open)
    }




    // fetchMyProducts = () => {
    //     this.setState({ isLoadingData: true })
    //     HttpServices.request('getProducts', {}, (fetchResult, fetchError, fetchStatus) => {
    //         this.setState({ isLoadingData: false })

    //         if (fetchError) {
    //             // console.log('fetchError', fetchError)
    //             return
    //         }
    //         // console.log('My product', fetchResult.info)
    //         this.setState({ myProducts: fetchResult.info })
    //     })
    // }

    setPhoto = (media) => {
        // let showphoto = this.state.showphoto
        // showphoto = media
        this.setState({ activeMedia: media })
    }

    getOneProduct = () => {
        // console.log('tttttttaada', this.props.windowData);
        // return
        let data = this.props.windowData.path[3]
        // console.log('tttttttaada', this.props.data);
        this.setState({ isLoadingData: true })
        HttpServices.request('getOneProduct', { _id: data }, (fetchResult, fetchError, fetchStatus) => {
            this.setState({ isLoadingData: false })

            if (fetchError) {
                console.log('fetchError', fetchError)
                return
            }
            // console.log('My product', fetchResult.info)
            let activeMedia = Array.isArray(fetchResult.info?.media) ? fetchResult.info?.media[0] : fetchResult.info?.media
            let activeVariants = {}

            if (Array.isArray(fetchResult.info?.variants)) {
                fetchResult.info?.variants.forEach(variant => {

                    if (Array.isArray(variant.options)) {
                        if (variant.name) {
                            activeVariants[variant.name.toLowerCase()] = variant.options[0]
                        }
                    }
                })
            }

            this.setState({ product: fetchResult.info, activeMedia, activeVariants }, () => {
                this.singleProductVariants.checkVariantsPrices()
            })
            this.checkCart()
        })
    }
    // getCart = () => {
    //     console.log('first')
    //     this.setState({ isLoadingData: true })
    //     HttpServices.request('addToCart', {}, (fetchResult, fetchError, fetchStatus) => {
    //         this.setState({ isLoadingData: false })

    //         if (fetchError) {
    //             console.log('fetchError', fetchError)
    //             this.setState({ cart: fetchError.cart }, () => {
    //                 this.checkCart()
    //             })
    //             return
    //         }
    //         console.log('My productttttttttttttttttt', fetchResult.info)
    //         this.setState({ cart: fetchResult.cart }, () => {
    //             this.checkCart()
    //         })
    //     })
    // }


    addToCart = (changeCount) => {

        console.log('first', this.state.product)
        this.props.addToCart(changeCount, this.state.product)
        // this.setState({ isLoadingData: true })
        // HttpServices.request('addToCart', { products: this.state.product, changeCount: changeCount }, (fetchResult, fetchError, fetchStatus) => {
        //     this.setState({ isLoadingData: false })

        //     if (fetchError) {
        //         console.log('fetchError', fetchError)
        //         return
        //     }
        //     console.log('My product', fetchResult)
        //     this.setState({ cart: fetchResult.newCart }, () => {
        //         this.checkCart()
        //         this.props.getCart()
        //     })
        // })
    }
    checkCart = () => {

        // console.log('llllllllll', this.props.cart, this.state.product);
        let productCount = 0
        for (let i = 0; i < this.props.cart?.info?.products?.length; i++) {
            const element = this.props?.cart?.info?.items[i];
            if (element.product?._id == this.state.product?._id) {
                // console.log('llllllllll', element);
                // exist = true
                productCount = element.count
            }
        }
        this.setState({ productCount }, () => {

        })
    }
    changePage = (page, link) => {
        this.props.changePage(page)
        this.props.changeWindowLink(link)
    }

    ShowImageModal = () => {
        this.ImageModal.showModal()
    }

    // checkVariantsPrices = () => {
    //     if (Array.isArray(this.state?.product?.variants) && this.state.activeVariants) {
    //         let activeVariants = this.state.activeVariants
    //         // let variants = this.state?.product?.variants

    //         if (Array.isArray(this.state?.product?.inventory?.variants)) {
    //             let final = {}
    //             let variantInventory = this.state?.product?.inventory?.variants
    //             let price = this.state?.product?.price?.final
    //             let variantsCount = this.state?.product?.variants.length


    //             variantInventory.forEach(element => {

    //                 if (element?.price?.final != price && element?.price?.final != null) {

    //                     let shouldBeConsidered = {}
    //                     let shouldNotBeConsidered = {}


    //                     for (const [key, value] of Object.entries(element.attributes)) {

    //                         // console.log(activeVariants)
    //                         // console.log(key, value, activeVariants[key])
    //                         if (activeVariants[key] == value) {
    //                             shouldBeConsidered[key] = { option: value, price: element.price }
    //                         } else {
    //                             shouldNotBeConsidered[key] = { option: value, price: element.price }
    //                         }

    //                     }

    //                     if (shouldBeConsidered) {
    //                         // console.log(shouldBeConsidered)
    //                         // console.log(element)
    //                         let keysLength = Object.keys(shouldBeConsidered).length
    //                         if (keysLength == variantsCount) {
    //                             final = shouldBeConsidered
    //                         }

    //                         if (keysLength == variantsCount - 1) {
    //                             final = shouldNotBeConsidered
    //                         }

    //                     }
    //                 }

    //             })

    //             console.log(final)
    //             this.setState({ variantsPriceDifferences: final })

    //         }
    //     }
    // }

    // changeVariant = (variant, option) => {

    //     let activeVariants = { ...this.state.activeVariants }

    //     if (variant.name) {
    //         let name = variant.name.toLowerCase()
    //         if (!activeVariants[name]) {
    //             activeVariants[name] = {}
    //         }
    //         activeVariants[name] = option

    //         // console.log(activeVariants)
    //         this.setState({ activeVariants }, () => {
    //             // this.checkVariantsPrices()
    //         })
    //     }
    // }

    // changeAdditional = (additional, option, isSelected) => {

    //     let activeAdditionals = this.state.activeAdditionals ? { ...this.state.activeAdditionals } : {}


    //     if (additional.type == 'text') {
    //         activeAdditionals[additional.title] = { text: { value: option } }
    //         if (!option || option.trim == '') {
    //             delete activeAdditionals[additional.title]
    //         }
    //         this.setState({ activeAdditionals })
    //         return
    //     }



    //     if (additional.type == 'singleSelect') {
    //         delete activeAdditionals[additional.title]
    //     }

    //     if (!activeAdditionals[additional.title]) {
    //         activeAdditionals[additional.title] = {}
    //     }



    //     if (isSelected) {
    //         delete activeAdditionals[additional.title][option.label]
    //     } else {
    //         activeAdditionals[additional.title][option.label] = { value: true }
    //     }

    //     if (Object.keys(activeAdditionals[additional.title]).length == 0) {
    //         delete activeAdditionals[additional.title]
    //     }

    //     this.setState({ activeAdditionals })



    // }

    setActiveVariant = (activeVariants, cb) => {

        this.setState({ activeVariants }, () => {
            cb()
        })
    }

    setActiveAdditionals = (activeAdditionals) => {

        this.setState({ activeAdditionals }, () => {
        })

    }


    render() {
        // let media = this.state?.product?.media ? [...this.state?.product?.media] : []
        // media.splice(0, 0, this.state?.product?.cover)
        let colors = this.props.colors
        let background = `linear-gradient(90deg, ${colors?.primaryColor}, ${colors?.secondaryColor})`

        // console.log(this.state?.product)
        return (

            <div className='h-100 scroll-no-scrollbar w-100 container '>
                <div className="d-flex flex-wrap mt-4" style={{ maxWidth: '1200px', margin: "auto" }}>
                    <Responsive className={''} width={this.props.width} media={this.props.col ?? { xs: "12", sm: '6', md: '6', lg: "6", xl: "6" }}>
                        <div style={{ position: 'sticky', top: 0 }}>

                            <div className=''>
                                <button className='w-100' style={{ margin: "auto" }} onClick={() => this.ShowImageModal()}>
                                    <img className='w-100 br-15' src={imageAddress(this.state.activeMedia)} alt="" />
                                </button>
                                <div className='flexc sc-gray2 mt-1' style={{ overflow: 'auto' }}>
                                    {Array.isArray(this.state.product?.media) && this.state.product?.media.map((prop, index) => {
                                        return (
                                            <button className='mrd-4' key={index} onClick={() => this.setPhoto(prop)}>
                                                <img className='br-15' width={80} src={imageAddress(prop)} />
                                            </button>
                                        )
                                    })}
                                </div>
                            </div>
                        </div>

                    </Responsive>



                    <Responsive className={''} width={this.props.width} media={this.props.col ?? { xs: "12", sm: '6', md: '6', lg: "6", xl: "6" }}>
                        <div className={'' + (this.props.width > 576 ? ' pld-6 ' : '') + (this.props.width > 576 ? '' : 'mt-4')} >

                            <div className='pb-3' style={{ borderBottom: "1px solid #ddd" }}>
                                {Array.isArray(this.state?.product?.label) && (
                                    <div className='flexc flex-wrap'>
                                        {this.state?.product?.label.map((prop, index) => {
                                            return (
                                                <p className='  mrd-3 text-small text-semibold' style={{ color: '#CC0C39' }}>{checkTranslation(prop)}</p>
                                            )
                                        })}
                                    </div>
                                )}

                                <p className='mt-1 mb-1 font-size-26 fw-600 text-big'>{checkTranslation(this.state?.product?.name)}</p>

                                {/* <p className='error-text font-size-12'> {this.state?.product?.price?.discount.value} % {translate('Discount')}</p> */}


                                <div className='flexc'>
                                    <p className='font-size-20 weight-600'> {this.state?.product?.price?.currency ?? '$'}{priceStandardView(this.state?.product?.price.final)}</p>

                                    {this.state.product?.price?.onSale && (
                                        <p className='font-size-14  px-1 text-semibold' style={{ color: '#777' }}>Was: <span className='text-lined'>{this.state?.product?.price?.currency ?? '$'}{this.state.product?.price?.base}</span></p>
                                    )}
                                </div>

                                {this.state.product?.price?.onSale && (
                                    <div className='flexc'>
                                        <div className='br-30 ' style={{ color: '#CC0C39' }}>
                                            <p className=' font-size-12 text-semibold'>{this.state?.product?.price?.discount.value}{this.state?.product?.discount?.unit ?? '%'} Discount</p>
                                        </div>
                                    </div>
                                )}


                                {this.state?.info?.status == '0' && (
                                    <button className="buy-btn" style={{ background: background ?? '#007aff' }}>{translate('Coming Soon')}</button>
                                )}
                                {this.state?.info?.status == '-1' && (
                                    <button className="buy-btn-de" style={{ background: background ?? '#007aff' }} >{translate('Discontinued')}</button>
                                )}
                                {!this.state?.info?.available && (
                                    <button className="buy-btn-os" style={{ background: background ?? '#007aff' }}>{translate('Out of Stuck')}</button>
                                )}

                            </div>


                            <div style={{}}>
                                {/* {this.state.singleAli.map((prop, index) => {
                                    return (
                                        <div className='d-flex mt-4 mb-4'>
                                            <img className='prd-3' style={{ height: '30px' }} src={prop.src} alt="" />
                                            <div>
                                                <p className='text-normal color-blue'>{checkTranslation(prop.title)}</p>
                                                <p className='font-size-14 des-color'>{checkTranslation(prop.text)}</p>
                                            </div>
                                        </div>
                                    )
                                })} */}
                                <div>
                                    <p className='font-size-14 py-3'>{this.state?.product?.description}</p>
                                </div>

                                <div className='mb-4'>

                                    {/* {console.log(this.state.activeAdditionals)} */}

                                    <SingleProductVariants ref={el => this.singleProductVariants = el} product={this.state?.product} activeVariants={this.state.activeVariants} setActiveVariant={this.setActiveVariant} />

                                    <SingleProductAdditionals product={this.state?.product} activeAdditionals={this.state.activeAdditionals} setActiveAdditionals={this.setActiveAdditionals} />


                                    {/* {Array.isArray(this.state?.product?.variants) == true && this.state?.product?.variants.map((variant, index) => {
                                        return (
                                            <div className='mb-3'>
                                                <p className='font-size-16 text-bold text-normal mb-2'>{variant?.name}</p>
                                                <div className='flexc flex-wrap'>
                                                    {Array.isArray(variant.options) && variant.options.map((option, index) => {
                                                        if (option.trim() != '') {
                                                            let isSelectedVariant = false
                                                            let name = variant.name ? variant.name.toLowerCase() : null

                                                            if (name && this.state.activeVariants && this.state.activeVariants[name]) {
                                                                if (this.state.activeVariants[name] == option) {
                                                                    isSelectedVariant = true
                                                                }
                                                            }
                                                            return (
                                                                <div className=' mrd-2 mb-1'>
                                                                    <button className=' br-4   flexc ' onClick={() => this.changeVariant(variant, option)} style={{ border: isSelectedVariant ? '0px solid transparent' : '1px solid #aaa' }}>
                                                                        <div className='br-4 px-3 py-1 flexc' style={{ padding: '0px', border: isSelectedVariant ? '2px solid #007aff' : '1px solid transparent', }}>

                                                                            <p className='text-small text-semibold'>{option}</p>

                                                                            {(this.state.variantsPriceDifferences[name] && this.state.variantsPriceDifferences[name].option == option) && (
                                                                                <p className='text-small mld-2 text-semibold' style={{ color: '#000' }}>${this.state.variantsPriceDifferences[name]?.price?.final}</p>
                                                                            )
                                                                            }
                                                                        </div>
                                                                    </button>
                                                                </div>
                                                            )
                                                        }
                                                    })}
                                                </div>
                                            </div>
                                        )
                                    })} */}




                                    {/* {Array.isArray(this.state?.product?.additionals) == true && this.state?.product?.additionals.map((additional, index) => {
                                        return (
                                            <div className='mb-3 '>
                                                <div className='flexcb mb-2'>
                                                    <p className='font-size-16 text-bold text-normal '>{additional?.title}</p>
                                                    {additional.required && (
                                                        <div className='br-20 px-2 py-1' style={{ backgroundColor: '#eee' }}>
                                                            <p className='text-smaller text-semibold'>{translate("Required")}</p>
                                                        </div>
                                                    )}
                                                </div>
                                                <div className='mt-3'>

                                                    {(additional.type == 'text') && (
                                                        <div className='bordered-input p-2'>
                                                            <TextAreaInput data={this.state.activeAdditionals ? this.state.activeAdditionals[additional.title]?.text?.value : ''} header={{ information: { rows: 4, placeholder: '{{lang}}Add a note' } }} changeValue={(key, value) => this.changeAdditional(additional, value)} />
                                                        </div>
                                                    )}


                                                    {Array.isArray(additional.options) && additional.options.map((option, index) => {

                                                        let isSelectedVariant = false

                                                        if (this.state.activeAdditionals && this.state.activeAdditionals[additional.title]) {
                                                            let activeAdditional = this.state.activeAdditionals[additional.title]

                                                            if (activeAdditional && activeAdditional[option.label]) {
                                                                isSelectedVariant = true
                                                            }
                                                        }
                                                      
                                                        return (
                                                            <div className=' mrd-2 mb-3  w-100'>
                                                                <button className='flexcb pb-3 w-100' onClick={() => this.changeAdditional(additional, option, isSelectedVariant)} style={{ borderBottom: '1px solid #eee' }}>
                                                                    <div className='text-start'>
                                                                        <p className='text-small text-semibold'>{option.label}</p>

                                                                        {(option.priceDifference && option.priceDifference != 0) && (
                                                                            <p className='text-small  ' style={{ color: '#000' }}>{option.priceDifference > 0 ? "+" : ''}${option.priceDifference}</p>
                                                                        )}
                                                                    </div>

                                                                    <div className='br-4 px-3 py-1 flexc' >

                                                                        {additional.type == 'singleSelect' && (

                                                                            <label className="checkbox-container " >
                                                                                <input type="checkbox" checked={isSelectedVariant} />
                                                                                <span className="radioMark"></span>
                                                                            </label>

                                                                        )}

                                                                        {(additional.type == 'multiSelect' || !additional.type) && (
                                                                            <label className="checkbox-container " >
                                                                                <input type="checkbox" checked={isSelectedVariant} />
                                                                                <span className="checkmark"></span>
                                                                            </label>
                                                                        )}



                                                                    </div>
                                                                </button>
                                                            </div>
                                                        )

                                                    })}
                                                </div>
                                            </div>
                                        )
                                    })} */}



                                </div>


                                {/* <div className='d-flex align-items-start py-3' >
                                    <img className='d-flex prd-3' style={{ marginTop: "-5px" }} src='/assets/icons/store.svg' />
                                    <div>
                                        <p className='font-size-14 des-color '>{translate('Order now. Pick up, in store:')}</p>
                                        <p className='font-size-14 des-color '><span className='title-color weight-500'>Today</span> at Apple Brickell City Centre</p>
                                    </div>
                                </div> */}
                                {/* <div className='d-flex align-items-start py-3' >
                                    <img className='d-flex prd-3' style={{ marginTop: "-5px", }} src='/assets/icons/truck.svg' />
                                    <div>
                                        <p className='font-size-14 des-color '>Order by 10:15 a.m..</p>
                                        <p className='font-size-14 weight-500 title-color '>Today from Store 10:30a.m. to 12:30p.m. — $9.00 Tue, Jan 17 — Free</p>
                                    </div>
                                </div> */}
                                {/* {this.state.productCount == 0 && (

                                    <button className='buy-btn w-100 font-size-15 br-10' style={{ padding: "10px 0px" }} onClick={() => this.addToCart(1)}>
                                    <p>Add to Cart</p>
                                </button>
                                    ) } */}


                                {/* you should use the button blow */}


                                <div className="d-flex mt-2">
                                    {/* {this.state?.info?.status == '1' && this.state?.info?.available && ( */}
                                    <AddToCardButton colors={this.props.colors} product={this.state.product} variables={this.state.activeVariants} applet={this.props.applet?._id??this.props.variables.appletId} additionals={this.state.activeAdditionals} variants={this.state.activeVariants} changePage={this.props.changePage} />
                                    {/* <>
                                        {(this.state.productCount == 0) ? (
                                            <button onClick={() => this.addToCart(1)} className="buy-btn font-size-15 br-6" style={{ padding: "10px 0px", background: background ?? '#007aff', width: '200px' }}>
                                                <p className='text-normall text-bold'>{translate("Add to cart")}</p>
                                            </button>
                                        ) : (
                                            <div className=" buy-btn flexcb br-6" style={{ padding: "10px 0px", background: background ?? '#007aff', width: '200px' }}>
                                                <button className='flexcc mx-2' onClick={() => this.addToCart(-1)} style={{ cursor: 'pointer' }}>
                                                    <img className='invert' src='/assets/icons/minimize.svg' width={20} />
                                                </button>
                                                <span style={{ fontSize: 15 }}>{this.state.productCount}
                                                </span>
                                                <button className='flexcc mx-2' onClick={() => this.addToCart(1)} style={{ cursor: 'pointer' }}>
                                                    <img className='invert' src='/assets/icons/plus.svg' width={20} />
                                                </button>
                                            </div>
                                        )}
                                    </> */}
                                    {/* )} */}

                                </div>


                                <div className='py-3 flexcb mt-3'>



                                    <div>
                                        <p className='font-size-15 weight-500 title-color'>{translate('Still deciding?')}</p>
                                        <p className='font-size-13 des-color'>{translate('Add this item to a list and easily come back to it later')}</p>
                                    </div>

                                    <div>
                                        <img onClick={() => this.setState({ save: !this.state.save })} style={{ display: this.state.save ? "none" : "block" }} className='cursor-pointer' height="25px" src="/assets/icons/bookmark-empty.svg" alt="" />
                                        <img onClick={() => this.setState({ save: !this.state.save })} style={{ display: this.state.save ? "block" : "none" }} className='cursor-pointer' height="25px" src="/assets/icons/bookmark-fill.svg" alt="" />
                                    </div>

                                </div>
                                <div className='w-100' style={{ borderBottom: '1px solid #ddd', margin: '10px auto' }}></div>
                                <div className='flexc my-3'>
                                    <img className='prd-3' height="30px" src="/assets/icons/message.svg" alt="" />
                                    <p className='font-size-14'>Need some help? <a className='text-link'>{translate('Contact us')}</a></p>
                                </div>
                            </div>
                        </div>
                    </Responsive>



                    {/* <div className='w-100 '>
                        <div className='mt-5 mb-5'>
                            <p className='font-size-20 weight-500 title-color'>{translate('Specification')}</p>
                        </div>
                        {this.state.specification.map((props, index) => {
                            return (
                                <div className=' d-md-flex mt-3 pb-5' style={{ borderBottom: "1px solid #ddd" }}>
                                    <div className='' style={{ width: "300px" }}>
                                        <p className='font-size-15 weight-500 title-color'>{checkTranslation(props.title)}</p>
                                    </div>
                                    <div className='w-100'>
                                        <p className='font-size-13 des-color weight-400'>{checkTranslation(props.des)}</p>
                                    </div>
                                </div>
                            )
                        })}
                    </div> */}

                    <div className='w-100 '>
                        <div className='my-3 pb-3'>

                            {Array.isArray(this.state.product?.sections) && this.state.product?.sections.map((props, index) => {

                                // console.log(props?.body)
                                return (
                                    <div className='py-4' style={{ borderBottom: "1px solid #ddd" }}>
                                        <div onClick={() => this.collapsOpen(index)} className='cursor-pointer flexcb'>
                                            <p className='font-size-20 weight-500'>{checkTranslation(props.title)}</p>
                                            <img style={{ transform: (this.state.collapsOpen[index]) ? "rotate(180deg)" : "", transition: 'all .5s ease' }} height="20px" src="/images/arrowbottom.png" alt="" />
                                        </div>
                                        <Collapsible open={this.state.collapsOpen[index]}>

                                            {props.type == 'editor' && (

                                                <div className='w-100 html-loader mt-2'>
                                                    <div className="title-color font-size-14" style={{ lineHeight: '24px' }} dangerouslySetInnerHTML={{ __html: props.body }}></div>
                                                </div>

                                            )}

                                            {props.type == 'specifications' && (
                                                <div className='w-100 mt-4 pt-1'>
                                                    {/* {Array.isArray(props.list) && props.list?.map((props, index) => {
                                                        return (
                                                            <div className='d-flex mt-4'>
                                                                <div className='mrd-5 prd-5 mt-2' style={{ width: "250px" }}>
                                                                    <p className='font-size-20 w-100'>{checkTranslation(props.title)}</p>
                                                                </div> */}
                                                    <div className='w-100 '>
                                                        {Array.isArray(props.list) && props.list?.map((item, index) => {
                                                            return (
                                                                <div className=' d-md-flex mt-3 pb-4' style={{ borderBottom: index < props.list.length - 1 ? "1px solid #ddd" : null }}>
                                                                    <div className='flex-1' style={{ maxWidth: "300px" }}>
                                                                        <p className='font-size-15 weight-500 title-color'>{checkTranslation(item.label)}</p>
                                                                    </div>
                                                                    <div className='w-100 flex-3'>
                                                                        <p className='font-size-13 des-color weight-400'>{checkTranslation(item.value)}</p>
                                                                    </div>
                                                                </div>
                                                            )
                                                        })}
                                                    </div>
                                                    {/* </div> */}
                                                    {/* )
                                                    })} */}
                                                </div>
                                            )}
                                        </Collapsible>
                                    </div>
                                )
                            })}



                            {/* {this.state.information.map((props, index) => {
                                return (
                                    <div className='py-4' style={{ borderBottom: "1px solid #ddd" }}>
                                        <div onClick={() => this.collapsOpen(index)} className='cursor-pointer flexcb'>
                                            <p className='font-size-18 weight-500'>{checkTranslation(props.name)}</p>
                                            <img style={{ transform: (this.state.collapsOpen[index]) ? "rotate(180deg)" : "", transition: 'all .5s ease' }} height="20px" src="/images/arrowbottom.png" alt="" />
                                        </div>
                                        <Collapsible open={this.state.collapsOpen[index]}>
                                            {props.children.map((props, index) => {
                                                return (
                                                    <div className='d-flex mt-4'>
                                                        <div className='mrd-5 prd-5 mt-2' style={{ width: "250px" }}>
                                                            <p className='font-size-20 w-100'>{checkTranslation(props.title)}</p>
                                                        </div>
                                                        <div className='w-100'>
                                                            {props.children.map((props, index) => {
                                                                return (
                                                                    <div className='mt-3'>
                                                                        <p className='title-color font-size-16'>{checkTranslation(props.title)}</p>
                                                                        <p className='des-color font-size-14'>{checkTranslation(props.des)}</p>
                                                                    </div>
                                                                )
                                                            })}
                                                        </div>
                                                    </div>
                                                )
                                            })}
                                        </Collapsible>
                                    </div>
                                )
                            })} */}
                        </div>
                    </div>
                    <div className=' mb-5 mt-2'>
                        <p className='font-size-20 weight-500 title-color'>{translate('Similar Products')}</p>
                        <DataGrid marginBottom={' my-2 flex-1'} width={this.props.width} isLoading={this.props.isLoadingData} data={this.state.myProducts} component={SimilarProducts} col={this.props.page?.grid ?? { xs: "12", sm: '6', md: '4', lg: "3", xl: "3" }} settings={{ edit: (this.props.page?.actions && Object.keys(this.props.page?.actions).length) > 0 ? true : false, openOptions: this.openOptions, onClick: this.props.changeStage }} />
                    </div>
                </div >
                <Modal maxWidth={600} ref={el => this.ImageModal = el}>
                    <div className="br-20 p-3 py-4 flexc flex-column" style={{ backgroundColor: '#fff', }}>
                        <div className='w-100 flexc flex-column' style={{ margin: "auto" }} >
                            <img className=' br-15' style={{ height: 'calc(100vh - 300px)', maxWidth: '100%', objectFit: 'contain' }} src={imageAddress(this.state.activeMedia)} alt="" />
                        </div>
                        <div className='flexc sc-gray2 mt-1 w-100 justify-content-center' style={{ overflow: 'auto' }}>


                            {Array.isArray(this.state.product?.media) && this.state.product?.media.map((prop, index) => {
                                return (
                                    <button className='mrd-2' key={index} onClick={() => this.setPhoto(prop)}>
                                        <img className='br-8' width={50} height={50} src={imageAddress(prop)} />
                                    </button>
                                )
                            })}
                        </div>
                    </div>
                </Modal>
            </div >

        )
    }
}

const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    { forwardRef: true }
)(SingleProduct);
